import { REACT_APP_API_URL } from '@/helpers/conf';
import {
  CASINO_PAYMENTS_REDIRECT_ROUTES,
  CDN_URLS,
  CLIENT_ENVS,
} from '@/helpers/constants';

export let isPaymentLibConfigured = false;

export const configPaymentsLib = () => {
  const origin = window.location.origin;
  const language = document.documentElement.lang || 'en';

  window.PaymentsAPI?.config({
    ...(CLIENT_ENVS.APP_ENV !== 'development' && {
      serverUrl: REACT_APP_API_URL,
    }),
    language,
    cdnList: CDN_URLS,
    contentPolicy: '4',
    redirectRoutes: {
      successUrl: `${origin}${CASINO_PAYMENTS_REDIRECT_ROUTES.SUCCESS}`,
      failureUrl: `${origin}${CASINO_PAYMENTS_REDIRECT_ROUTES.FAILURE}`,
      pendingUrl: `${origin}${CASINO_PAYMENTS_REDIRECT_ROUTES.PENDING}`,
      supportUrl: `${origin}${CASINO_PAYMENTS_REDIRECT_ROUTES.SUPPORT}`,
    },
  })
    .then(() => {
      console.log('usePaymentsAPIReady:configPaymentsLib');
      if (window.PaymentsAPI) {
        isPaymentLibConfigured = true;
      }
    })
    .catch((error) => {
      console.error('usePaymentsAPIReady:configPaymentsLib error', error);
    });
};
